import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useParentAuth } from "@/context/ParentAuthContext";
import { toast } from "sonner";
import { localReturnPath } from "@/lib/api";
import { ArrowRight, LogIn } from "lucide-react";

export default function ParentLogin() {
  const { login } = useParentAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next");
  const [f, setF] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(f.email.trim().toLowerCase(), f.password);
      toast.success("Signed in");
      nav(localReturnPath(next));
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Could not sign in");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-5 py-16 md:py-24">
      <div className="w-14 h-14 rounded-2xl bg-[#FFBF69]/25 grid place-items-center text-[#B36906]"><LogIn className="w-6 h-6" /></div>
      <h1 className="mt-6 font-display font-black text-4xl tracking-tight">Parent sign in</h1>
      <p className="mt-3 text-[#7A7D8C]">Check your cuber's results and competition history.</p>

      <form onSubmit={submit} className="mt-8 bg-white rounded-3xl border border-slate-100 p-6 space-y-4" data-testid="parent-login-form">
        <div>
          <label className="text-xs uppercase tracking-wider font-semibold text-[#7A7D8C]">Email</label>
          <input data-testid="login-email" type="email" value={f.email} required onChange={(e) => setF({ ...f, email: e.target.value })} className="mt-1 w-full rounded-xl border border-slate-200 bg-[#FDFFFC] px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#FF9F1C]" />
        </div>
        <div>
          <label className="text-xs uppercase tracking-wider font-semibold text-[#7A7D8C]">Password</label>
          <input data-testid="login-password" type="password" value={f.password} required onChange={(e) => setF({ ...f, password: e.target.value })} className="mt-1 w-full rounded-xl border border-slate-200 bg-[#FDFFFC] px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#FF9F1C]" />
        </div>
        <button disabled={busy} type="submit" data-testid="login-submit" className="w-full inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-[#FF9F1C] text-white font-bold shadow-[0_12px_30px_rgb(255,159,28,0.35)] hover:-translate-y-0.5 transition-transform disabled:opacity-60">
          {busy ? "Signing in…" : "Sign in"} <ArrowRight className="w-4 h-4" />
        </button>
        <p className="text-xs text-[#7A7D8C] text-center">New here? <Link to={`/parent/signup${next ? `?next=${encodeURIComponent(next)}` : ""}`} className="text-[#FF9F1C] font-semibold">Create an account</Link></p>
      </form>
    </div>
  );
}
